var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActionHeart = function SvgActionHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 4C19.67 4 21 6.22 21 9c0 5.63-8.84 11-9 11-.16 0-9-5.37-9-11 0-2.78 1.33-5 4.5-5 1.82 0 3.81 2.2 4.5 3 .69-.8 2.68-3 4.5-3",
    clipRule: "evenodd"
  })));
};
export default SvgActionHeart;